import { Record, Map } from 'immutable';

export default class AdStateContainerRecord extends Record({
  key: '',
  artboard: '',
  selected: false,
  isFixed: false,
  dimensions: Map({ left: 0, top: 0, width: 0, height: 0 }),
}) { }



// WEBPACK FOOTER //
// ./app/javascript/packs/App/Preview/records/AdStateContainerRecord.js